import{GET_LOCATION_DATA} from '../constants/data'


const reducer = (state={locationData:{}},action)=>{

    switch(action.type){
        case GET_LOCATION_DATA:
            localStorage.setItem('profile1',JSON.stringify({...action.payload}))
            return {...state,locationData:action.payload}

        default:
            return state
    }

}

export default reducer;